module.exports = __webpack_public_path__ + "img/marquee.14a0235d.gif";